import React, { useEffect, useState } from 'react';
import AdminLoginWrapper from '../components/AdminLoginWrapper'; // <-- NEW IMPORT

/* 
|--------------------------------------------------------------------------
| STYLE OBJECTS
|--------------------------------------------------------------------------
*/
const containerStyle = {
  padding: '1rem',
  fontFamily: 'sans-serif',
  color: '#333',
  maxWidth: '1200px',
  margin: '0 auto',
};

const headingStyle = {
  marginBottom: '1.5rem',
};

const controlsBarStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
  marginBottom: '1rem',
};

const inputStyle = {
  padding: '0.5rem',
  border: '1px solid #ccc',
  borderRadius: '4px',
};

/**
 * Base select style, plus custom arrow icon & removing default select arrow.
 */
const customSelectStyle = {
  padding: '0.5rem',
  border: '1px solid #ccc',
  borderRadius: '4px',
  appearance: 'none',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  // Custom arrow:
  background:
    'url("data:image/svg+xml;charset=utf8,%3Csvg fill=\'%23000\' height=\'24\' viewBox=\'0 0 24 24\' width=\'24\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M7 10l5 5 5-5z\'/%3E%3Cpath d=\'M0 0h24v24H0z\' fill=\'none\'/%3E%3C/svg%3E") no-repeat right 0.75rem center / 1rem',
  paddingRight: '2rem',
};

const tableWrapperStyle = {
  width: '100%',
  overflowX: 'auto',
  marginTop: '1rem',
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
};

const thTdStyle = {
  padding: '0.75rem 1rem',
  borderBottom: '1px solid #ddd',
  textAlign: 'left',
  whiteSpace: 'nowrap',
};

const trHoverStyle = {
  cursor: 'pointer',
};

const highlightedRowStyle = {
  backgroundColor: '#CCE5FF', // Light blue highlight
};

const errorStyle = {
  color: 'red',
  marginTop: '1rem',
};

const detailCardStyle = {
  marginTop: '1rem',
  backgroundColor: '#f9f9f9',
  padding: '1rem',
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
};

const actionButtonContainerStyle = {
  display: 'flex',
  gap: '0.5rem',
  marginTop: '0.5rem',
};

const actionButtonStyle = {
  backgroundColor: '#007BFF',
  color: '#fff',
  border: 'none',
  padding: '0.5rem 1rem',
  borderRadius: '4px',
  cursor: 'pointer',
};

const dismissButtonStyle = {
  ...actionButtonStyle,
  backgroundColor: '#6c757d',
};

const warnButtonStyle = {
  ...actionButtonStyle,
  backgroundColor: '#ffc107',
  color: '#000',
};

const banButtonStyle = {
  ...actionButtonStyle,
  backgroundColor: '#dc3545',
};

const tempBanButtonStyle = {
  ...actionButtonStyle,
  backgroundColor: '#fd7e14',
};

const expandToggleButtonStyle = {
  ...actionButtonStyle,
  backgroundColor: '#17a2b8',
};

const smallCardStyle = {
  border: '1px solid #ddd',
  borderRadius: '8px',
  margin: '0.5rem 0',
  padding: '0.75rem',
  backgroundColor: '#fafafa',
};

/* 
|--------------------------------------------------------------------------
| 1) HELPER: getAuthHeaders() => add Authorization: Bearer <token> (if needed)
|--------------------------------------------------------------------------
*/
function getAuthHeaders() {
  const token = localStorage.getItem('adminToken') || '';
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

/*
|--------------------------------------------------------------------------
| 2) TABBED UI, MAIN REPORT LIST, etc. (Your existing code)
|--------------------------------------------------------------------------
*/
function TabBar({ activeTab, onTabChange }) {
  const tabButtonStyle = (tab) => ({
    fontWeight: activeTab === tab ? 'bold' : 'normal',
    marginRight: '8px',
    padding: '0.5rem 1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    cursor: 'pointer',
    backgroundColor: activeTab === tab ? '#e6e6e6' : '#f9f9f9',
  });

  return (
    <div style={{ marginBottom: '1rem' }}>
      <button style={tabButtonStyle('new')} onClick={() => onTabChange('new')}>
        New
      </button>
      <button
        style={tabButtonStyle('under_review')}
        onClick={() => onTabChange('under_review')}
      >
        Under Review
      </button>
      <button
        style={tabButtonStyle('completed')}
        onClick={() => onTabChange('completed')}
      >
        Completed
      </button>
    </div>
  );
}

function ReportList({ reports, selectedReport, onSelectReport }) {
  return (
    <div style={tableWrapperStyle}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thTdStyle}>Ticket #</th>
            <th style={thTdStyle}>Reporter</th>
            <th style={thTdStyle}>Reported User</th>
            <th style={thTdStyle}>Reason</th>
            <th style={thTdStyle}>Status</th>
            <th style={thTdStyle}>Created At</th>
          </tr>
        </thead>
        <tbody>
          {reports.length === 0 ? (
            <tr>
              <td colSpan={6} style={{ textAlign: 'center', padding: '1rem' }}>
                No reports found.
              </td>
            </tr>
          ) : (
            reports.map((r) => {
              const isHighlighted = selectedReport?._id === r._id;
              return (
                <tr
                  key={r._id}
                  style={{
                    ...trHoverStyle,
                    ...(isHighlighted ? highlightedRowStyle : {}),
                  }}
                  onClick={() => onSelectReport(r)}
                >
                  <td style={thTdStyle}>{r._id}</td>
                  <td style={thTdStyle}>{r.reporterId?.email}</td>
                  <td style={thTdStyle}>{r.reportedUserId?.email}</td>
                  <td style={thTdStyle}>{r.reason}</td>
                  <td style={thTdStyle}>{r.status}</td>
                  <td style={thTdStyle}>
                    {r.createdAt
                      ? new Date(r.createdAt).toLocaleString()
                      : 'N/A'}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}

// Convert Date-of-Birth to numeric age
function calculateAge(dob) {
  if (!dob) return '';
  const diff = Date.now() - new Date(dob).getTime();
  const ageDt = new Date(diff);
  return Math.abs(ageDt.getUTCFullYear() - 1970);
}

// aggregator for reasons => counts
function getReasonCounts(reportArray) {
  const counts = {};
  (reportArray || []).forEach((r) => {
    const reason = r.reason || 'Unknown';
    if (!counts[reason]) counts[reason] = 0;
    counts[reason]++;
  });
  return counts;
}

function ReportDetail({ report, status, onClose }) {
  const [notes, setNotes] = useState(report.moderatorNotes || '');
  const [extendedData, setExtendedData] = useState(null);

  const [showReporterDetails, setShowReporterDetails] = useState(false);
  const [showReporterReports, setShowReporterReports] = useState(false);

  const [showReportedUserDetails, setShowReportedUserDetails] = useState(false);
  const [showReportedUserReports, setShowReportedUserReports] = useState(false);

  // Replace with actual moderator ID if needed
  const myModeratorId = '1234567890abcdef12345678';

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/admin/moderation/reports/${report._id}/details`, {
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          setExtendedData(data);
        }
      })
      .catch((err) => console.error('Error fetching extended data:', err));
  }, [report._id]);

  // ACTION HANDLERS
  function handleAssignToMe() {
    fetch(`${process.env.REACT_APP_API_URL}/admin/moderation/reports/${report._id}/assign`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify({ moderatorId: myModeratorId }),
    })
      .then((res) => res.json())
      .then(() => {
        alert('Assigned to you!');
      })
      .catch((err) => console.error('Error assigning:', err));
  }

  function handleUpdateNotes() {
    fetch(`${process.env.REACT_APP_API_URL}/admin/moderation/reports/${report._id}/notes`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify({ notes }),
    })
      .then((res) => res.json())
      .then(() => {
        alert('Notes updated!');
      })
      .catch((err) => console.error('Error updating notes:', err));
  }

  function handleFinalize(resolution) {
    fetch(`${process.env.REACT_APP_API_URL}/admin/moderation/reports/${report._id}/finalize`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ resolution }),
    })
      .then((res) => res.json())
      .then(() => {
        alert(`Report finalized with: ${resolution}`);
        onClose(); // close the detail panel
      })
      .catch((err) => console.error('Error finalizing:', err));
  }

  function handleRevert() {
    fetch(`${process.env.REACT_APP_API_URL}/admin/moderation/reports/${report._id}/revert`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          alert(data.error);
        } else {
          alert('Report reverted successfully!');
          onClose();
        }
      })
      .catch((err) => console.error('Error reverting:', err));
  }

  // RENDER: SOCIALS
  function renderSocials(socialsObj) {
    if (!socialsObj || typeof socialsObj !== 'object') return <p>N/A</p>;
    const entries = Object.entries(socialsObj);
    if (entries.length === 0) return <p>N/A</p>;

    return (
      <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
        {entries.map(([platform, data], idx) => {
          if (typeof data === 'string') {
            return (
              <li key={platform + idx}>
                <strong>{platform}:</strong>{' '}
                <a href={data} target="_blank" rel="noreferrer">
                  {data}
                </a>
              </li>
            );
          }
          if (typeof data === 'object') {
            const { url, handle } = data;
            return (
              <li key={platform + idx}>
                <strong>{platform}:</strong>{' '}
                {url ? (
                  <a href={url} target="_blank" rel="noreferrer">
                    {handle || url}
                  </a>
                ) : (
                  handle || JSON.stringify(data)
                )}
              </li>
            );
          }
          return null;
        })}
      </ul>
    );
  }

  function renderReportsOverview(reportArray) {
    const reasonCounts = getReasonCounts(reportArray || []);
    const reasons = Object.keys(reasonCounts);
    if (reasons.length === 0) return <p>None</p>;

    return (
      <div>
        <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
          {reasons.map((reason) => (
            <li key={reason}>
              {reason}: {reasonCounts[reason]}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  function renderReportsList(reportArray, keySuffix) {
    if (!reportArray || reportArray.length === 0) {
      return <p>No previous reports found.</p>;
    }
    return (
      <>
        {reportArray.map((rpt) => (
          <div key={String(rpt._id) + keySuffix} style={smallCardStyle}>
            <p>
              <strong>Ticket #:</strong> {rpt._id}
            </p>
            <p>
              <strong>Reason:</strong> {rpt.reason}
            </p>
            <p>
              <strong>Details:</strong> {rpt.details || 'N/A'}
            </p>
            <p>
              <strong>Created At:</strong>{' '}
              {new Date(rpt.createdAt).toLocaleString()}
            </p>
          </div>
        ))}
      </>
    );
  }

  return (
    <div style={{ ...detailCardStyle, width: '600px', minWidth: '300px' }}>
      <h2 style={headingStyle}>Report Detail</h2>
      <p>
        <strong>Ticket #:</strong> {report._id}
      </p>
      <p>
        <strong>Reporter:</strong> {report.reporterId?.email}
      </p>
      <p>
        <strong>Reported User:</strong> {report.reportedUserId?.email}
      </p>
      <p>
        <strong>Reason:</strong> {report.reason}
      </p>
      <p>
        <strong>Details:</strong> {report.details || 'N/A'}
      </p>
      <p>
        <strong>Current Status:</strong> {report.status}
      </p>

      {/* Moderator Notes */}
      <div style={{ marginTop: '1rem' }}>
        <h3>Moderator Notes</h3>
        {status === 'under_review' ? (
          <>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Moderator notes here..."
              rows={3}
              style={{
                width: '100%',
                marginBottom: '0.5rem',
                padding: '0.5rem',
                fontFamily: 'sans-serif',
              }}
            />
            <button style={actionButtonStyle} onClick={handleUpdateNotes}>
              Save Notes
            </button>
          </>
        ) : (
          <p style={{ whiteSpace: 'pre-line' }}>{notes || 'No notes yet.'}</p>
        )}
      </div>

      {extendedData && (
        <div
          style={{
            marginTop: '1rem',
            padding: '1rem',
            borderRadius: '8px',
            backgroundColor: '#fff',
            border: '1px solid #ddd',
          }}
        >
          {/* ---------------- Reporter Info --------------- */}
          <h3>Reporter Additional Info</h3>
          <button
            style={expandToggleButtonStyle}
            onClick={() => setShowReporterDetails(!showReporterDetails)}
          >
            {showReporterDetails ? 'Hide' : 'Show'} Reporter Profile
          </button>
          {showReporterDetails && (
            <div
              style={{
                marginTop: '0.75rem',
                borderLeft: '3px solid #ccc',
                paddingLeft: '1rem',
              }}
            >
              <p>
                <strong>Name:</strong> {extendedData.reporter?.firstName}{' '}
                {extendedData.reporter?.lastName}
              </p>
              <p>
                <strong>Email:</strong> {extendedData.reporter?.email}
              </p>
              <p>
                <strong>Gender:</strong> {extendedData.reporter?.gender}
              </p>
              <p>
                <strong>Age:</strong> {calculateAge(extendedData.reporter?.dateOfBirth)}
              </p>
              <p>
                <strong>About Me:</strong> {extendedData.reporter?.overview}
              </p>

              <p>
                <strong>Socials:</strong>
              </p>
              {renderSocials(extendedData.reporter?.socials)}

              <p>
                <strong>Interests:</strong>{' '}
                {extendedData.reporter?.interests?.join(', ') || 'N/A'}
              </p>
              <p>
                <strong>Strikes:</strong> {extendedData.reporter?.strikes}
              </p>
              <p>
                <strong>Reports Created:</strong>{' '}
                {extendedData.reporter?.createdCount}
              </p>
              <p>
                <strong>Reports Received:</strong>{' '}
                {extendedData.reporter?.receivedCount}
              </p>

              <h4 style={{ marginTop: '1rem' }}>Previous Reports Created: Summary</h4>
              {renderReportsOverview(extendedData.reporter?.previousCreatedReports)}
              <button
                style={expandToggleButtonStyle}
                onClick={() => setShowReporterReports(!showReporterReports)}
              >
                {showReporterReports ? 'Hide' : 'Show'} Detailed Created Reports
              </button>
              {showReporterReports && (
                <div style={{ marginTop: '0.5rem' }}>
                  {renderReportsList(
                    extendedData.reporter?.previousCreatedReports,
                    'reporterCreated'
                  )}
                </div>
              )}

              <ReporterReceivedReportsBlock
                receivedReports={extendedData.reporter?.previousReceivedReports}
              />
            </div>
          )}

          <hr style={{ margin: '1rem 0' }} />

          {/* ---------------- Reported User Info -------------- */}
          <h3>Reported User Additional Info</h3>
          <button
            style={expandToggleButtonStyle}
            onClick={() => setShowReportedUserDetails(!showReportedUserDetails)}
          >
            {showReportedUserDetails ? 'Hide' : 'Show'} Reported User Profile
          </button>
          {showReportedUserDetails && (
            <div
              style={{
                marginTop: '0.75rem',
                borderLeft: '3px solid #ccc',
                paddingLeft: '1rem',
              }}
            >
              <p>
                <strong>Name:</strong> {extendedData.reportedUser?.firstName}{' '}
                {extendedData.reportedUser?.lastName}
              </p>
              <p>
                <strong>Email:</strong> {extendedData.reportedUser?.email}
              </p>
              <p>
                <strong>Gender:</strong> {extendedData.reportedUser?.gender}
              </p>
              <p>
                <strong>Age:</strong> {calculateAge(extendedData.reportedUser?.dateOfBirth)}
              </p>
              <p>
                <strong>About Me:</strong> {extendedData.reportedUser?.overview}
              </p>

              <p>
                <strong>Socials:</strong>
              </p>
              {renderSocials(extendedData.reportedUser?.socials)}

              <p>
                <strong>Interests:</strong>{' '}
                {extendedData.reportedUser?.interests?.join(', ') || 'N/A'}
              </p>
              <p>
                <strong>Strikes:</strong> {extendedData.reportedUser?.strikes}
              </p>
              <p>
                <strong>Reports Created:</strong>{' '}
                {extendedData.reportedUser?.createdCount}
              </p>
              <p>
                <strong>Reports Received:</strong>{' '}
                {extendedData.reportedUser?.receivedCount}
              </p>

              <h4 style={{ marginTop: '1rem' }}>Previous Reports Created: Summary</h4>
              {renderReportsOverview(extendedData.reportedUser?.previousCreatedReports)}
              <button
                style={expandToggleButtonStyle}
                onClick={() => setShowReportedUserReports(!showReportedUserReports)}
              >
                {showReportedUserReports ? 'Hide' : 'Show'} Detailed Created Reports
              </button>
              {showReportedUserReports && (
                <div style={{ marginTop: '0.5rem' }}>
                  {renderReportsList(
                    extendedData.reportedUser?.previousCreatedReports,
                    'reportedUserCreated'
                  )}
                </div>
              )}

              <h4 style={{ marginTop: '1rem' }}>Previous Reports Received: Summary</h4>
              {renderReportsOverview(extendedData.reportedUser?.previousReceivedReports)}
            </div>
          )}
        </div>
      )}

      {/* ACTIONS */}
      <div style={{ marginTop: '1rem' }}>
        {status === 'new' && (
          <button style={actionButtonStyle} onClick={handleAssignToMe}>
            Assign to Me
          </button>
        )}

        {status === 'under_review' && (
          <>
            <h3 style={{ marginTop: '1rem' }}>Finalize</h3>
            <div style={actionButtonContainerStyle}>
              <button
                style={dismissButtonStyle}
                onClick={() => handleFinalize('dismiss')}
              >
                Dismiss
              </button>
              <button
                style={warnButtonStyle}
                onClick={() => handleFinalize('warn')}
              >
                Warn
              </button>
              <button
                style={tempBanButtonStyle}
                onClick={() => handleFinalize('tempBan')}
              >
                Temp Ban
              </button>
              <button
                style={banButtonStyle}
                onClick={() => handleFinalize('ban')}
              >
                Ban
              </button>
            </div>
          </>
        )}

        {status === 'completed' && (
          <>
            <p style={{ marginTop: '1rem' }}>
              <strong>Resolution:</strong> {report.resolution}
            </p>
            <div style={actionButtonContainerStyle}>
              <button style={actionButtonStyle} onClick={onClose}>
                Close
              </button>
              <button style={warnButtonStyle} onClick={handleRevert}>
                Revert to Under Review
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function ReporterReceivedReportsBlock({ receivedReports }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <h4 style={{ marginTop: '1rem' }}>Previous Reports Received: Summary</h4>
      {renderReportsOverview(receivedReports)}
      <button style={expandToggleButtonStyle} onClick={() => setShow(!show)}>
        {show ? 'Hide' : 'Show'} Detailed Received Reports
      </button>
      {show && (
        <div style={{ marginTop: '0.5rem' }}>
          {renderReportsList(receivedReports, 'reporterReceived')}
        </div>
      )}
    </>
  );
}

// Re-use aggregator & list
function renderReportsOverview(reportArray) {
  const reasonCounts = getReasonCounts(reportArray || []);
  const reasons = Object.keys(reasonCounts);
  if (reasons.length === 0) return <p>None</p>;

  return (
    <div>
      <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
        {reasons.map((reason) => (
          <li key={reason}>
            {reason}: {reasonCounts[reason]}
          </li>
        ))}
      </ul>
    </div>
  );
}

function renderReportsList(reportArray, keySuffix) {
  if (!reportArray || reportArray.length === 0) {
    return <p>No previous reports found.</p>;
  }
  return (
    <>
      {reportArray.map((rpt) => (
        <div key={String(rpt._id) + keySuffix} style={smallCardStyle}>
          <p>
            <strong>Ticket #:</strong> {rpt._id}
          </p>
          <p>
            <strong>Reason:</strong> {rpt.reason}
          </p>
          <p>
            <strong>Details:</strong> {rpt.details || 'N/A'}
          </p>
          <p>
            <strong>Created At:</strong>{' '}
            {new Date(rpt.createdAt).toLocaleString()}
          </p>
        </div>
      ))}
    </>
  );
}

/* 
|--------------------------------------------------------------------------
| 3) MODERATION PANEL (MAIN EXPORT), now wrapped by AdminLoginWrapper
|--------------------------------------------------------------------------
*/
export default function ModerationPanel() {
  return (
    <AdminLoginWrapper>
      <ModerationPanelInner />
    </AdminLoginWrapper>
  );
}

/**
 * This is your actual Moderation Panel logic (the original code),
 * expecting valid admin credentials (token) from AdminLoginWrapper.
 */
function ModerationPanelInner() {
  const [activeTab, setActiveTab] = useState('new');
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Additional states for search/filter/sort
  const [searchTerm, setSearchTerm] = useState('');
  const [reasonFilter, setReasonFilter] = useState('');
  const [sortOrder, setSortOrder] = useState('desc'); // 'desc' or 'asc'

  // For row highlight / selection
  const [selectedReport, setSelectedReport] = useState(null);
  const [allReasons, setAllReasons] = useState([]);

  useEffect(() => {
    fetchAllReportsForReasons();
  }, []);

  useEffect(() => {
    fetchReports(activeTab);
  }, [activeTab]);

  // 1) Fetch all reports (any status) for the reason dropdown
  async function fetchAllReportsForReasons() {
    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_API_URL}/admin/moderation/reports`, {
        headers: getAuthHeaders(),
      });
      if (!res.ok) {
        throw new Error(`Failed to fetch all reports: ${res.statusText}`);
      }
      const data = await res.json();
      const uniqueReasons = new Set();
      data.forEach((r) => {
        if (r.reason) uniqueReasons.add(r.reason);
      });
      setAllReasons(Array.from(uniqueReasons));
    } catch (err) {
      console.error('Error fetching all reports for reasons:', err);
    }
    setLoading(false);
  }

  // 2) Fetch only the reports for the current tab (status)
  async function fetchReports(status) {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/admin/moderation/reports/filter?status=${status}`,
        { headers: getAuthHeaders() }
      );
      if (!res.ok) {
        throw new Error(`Failed to fetch reports: ${res.statusText}`);
      }
      const data = await res.json();
      setReports(data);
      setSelectedReport(null);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  }

  // Filter, search, sort
  function getFilteredReports() {
    let filtered = [...reports];

    // Search by ticket number
    if (searchTerm.trim()) {
      filtered = filtered.filter((r) =>
        String(r._id).toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by reason
    if (reasonFilter) {
      filtered = filtered.filter((r) => r.reason === reasonFilter);
    }

    // Sort by date
    filtered.sort((a, b) => {
      const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return sortOrder === 'asc' ? aTime - bTime : bTime - aTime;
    });

    return filtered;
  }

  const displayedReports = getFilteredReports();

  return (
    <div style={containerStyle}>
      <h2 style={headingStyle}>Moderation Panel (New)</h2>
      <TabBar activeTab={activeTab} onTabChange={setActiveTab} />

      {/* Controls: Search, Filter, Sort */}
      <div style={controlsBarStyle}>
        <input
          style={inputStyle}
          type="text"
          placeholder="Search Ticket #"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <select
          style={customSelectStyle}
          value={reasonFilter}
          onChange={(e) => setReasonFilter(e.target.value)}
        >
          <option value="">Filter by Reason (All)</option>
          {allReasons.map((reason) => (
            <option key={reason} value={reason}>
              {reason}
            </option>
          ))}
        </select>

        <select
          style={customSelectStyle}
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
        >
          <option value="desc">Sort: Newest to Oldest</option>
          <option value="asc">Sort: Oldest to Newest</option>
        </select>
      </div>

      {loading && <p>Loading reports...</p>}
      {error && <p style={errorStyle}>{error}</p>}

      <div style={{ display: 'flex', gap: '1rem' }}>
        <ReportList
          reports={displayedReports}
          selectedReport={selectedReport}
          onSelectReport={(r) => setSelectedReport(r)}
        />

        {selectedReport && (
          <ReportDetail
            report={selectedReport}
            status={activeTab}
            onClose={() => setSelectedReport(null)}
          />
        )}
      </div>
    </div>
  );
}
